import baseAvatar from '@/assets/avatar.svg'
import aliceAvatar from '@/assets/channels-avatar.svg'

import { getMessagesContext } from './utils'
const highlightedMessage = state => {
  const reversedMessages = [].concat(state.filtered).reverse()
  return (
    reversedMessages.findIndex(message => message.id === state.highlight) + 1
  )
}

const filteredCount = state => state.filtered.length

const getDraftMessage = state => (channelId, isPrivate) =>
  state.draft.find(
    draft => draft.channelId === channelId && draft.isPrivate === isPrivate
  )

const currentMessages = state => {
  const array = getMessagesContext(state.isPrivate)
  return state.formattedCurrentMessages[array]
}

const isFromMember = (state, getters, rootState) => message => {
  if (rootState.pillars.channel.currentChannel) {
    return (
      message.userId ===
      rootState.pillars.channel.currentChannel.channelPersonId
    )
  }
}
const getMessageSender =
  (state, getters, rootState, rootGetters) => message => {
    if (getters.isFromMember(message)) {
      return (
        rootGetters['pillars/channel/channelMember'] || {
          photoURL: baseAvatar,
          participantName: 'Membro'
        }
      )
    }

    const staff = rootGetters[
      'pillars/channel/currentChannel'
    ].staffsArray.find(staff => staff.id === message.userId)
    if (staff)
      return {
        photoURL: staff.profileImageUrl,
        participantName: staff.fullName
      }

    return {
      photoURL: aliceAvatar,
      participantName: 'Alice'
    }
  }

export default {
  highlightedMessage,
  filteredCount,
  getDraftMessage,
  currentMessages,
  isFromMember,
  getMessageSender
}
